import { ModelBase } from '../../model/model-base';

export class AutoCompleteModel extends ModelBase {
  constructor(caption: string, id: string) {
    super();
    this.id = id;
    this.caption = caption;
  }
  caption: string;

  toString(culture?: string): string {
    return this.caption;
  }
}
